import { MailingListListLayout } from '../../features/mailinglist/navigation/MailingListListLayout';
import { ProjectsListLayout } from '../../features/projects/navigation/ProjectsListLayout';

export const dashboardNavRenderers = {
  mailinglist: MailingListListLayout,
  projects: ProjectsListLayout,
};
